import { render, staticRenderFns } from "./LandlordDetail.vue?vue&type=template&id=5dad4c0e&"
import script from "./LandlordDetail.vue?vue&type=script&lang=js&"
export * from "./LandlordDetail.vue?vue&type=script&lang=js&"
import style0 from "./LandlordDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LandlordDetail.vue"
export default component.exports